// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__tJMag","Icon":"Search_Icon__QxPDw","Input":"Search_Input__pf0r7"};